import listSaga from './listSaga'
import createSaga from './createSaga'
import editSaga from './editSaga'
import getGoogleAuthUrlSaga from './getGoogleAuthUrlSaga'
import oneEmailCredentialSaga from './oneEmailCredentialSaga'
import deleteEmailCredentialSaga from './deleteSaga'
import CheckSesAccountStatusSaga from './checkSesAccountStatusSaga'

const emailCredentialSagas = [
    listSaga(),
    createSaga(),
    editSaga(),
    getGoogleAuthUrlSaga(),
    oneEmailCredentialSaga(),
    deleteEmailCredentialSaga(),
    CheckSesAccountStatusSaga()
]

export default emailCredentialSagas
